import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { JobForm, JobFormData } from '@/components/JobForm';
import { useJob } from '@/hooks/useJobs';
import { useUpdateJob } from '@/hooks/useUpdateJob';
import { pipelineApi } from '@/lib/pipeline-api';
import { AppLayout } from '@/components/AppLayout';

export default function EditJobPage() {
  const { jobId } = useParams<{ jobId: string }>();
  const navigate = useNavigate();
  const { job, isLoading: loadingJob } = useJob(jobId!);
  const { updateJob, isLoading: updating } = useUpdateJob();

  const handleSubmit = async (data: JobFormData) => {
    try {
      await updateJob(jobId!, data);
      // Save pipeline config separately via pipeline API
      if (data.pipelineConfig) {
        await pipelineApi.updatePipelineConfig(jobId!, data.pipelineConfig);
      }
      toast.success('Vaga atualizada com sucesso!');
      navigate('/jobs');
    } catch (error) {
      console.error('Failed to update job:', error);
      toast.error('Erro ao atualizar vaga. Tente novamente.');
    }
  };

  if (loadingJob) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-muted-foreground">Carregando...</p>
      </div>
    );
  }

  if (!job) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <p className="text-destructive mb-4">Vaga não encontrada</p>
          <Button onClick={() => navigate('/jobs')}>Voltar para Vagas</Button>
        </div>
      </div>
    );
  }

  return (
    <AppLayout
      actions={
        <Button variant="outline" onClick={() => navigate(`/jobs/${jobId}`)}>
          Voltar
        </Button>
      }
    >
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-8">
          <h2 className="text-3xl font-bold mb-2">Editar Vaga</h2>
          <p className="text-muted-foreground">
            Atualize as informações da vaga
          </p>
        </div>

        <JobForm job={job} onSubmit={handleSubmit} isLoading={updating} />
      </div>
    </AppLayout>
  );
}
